import { capitalize } from '@material-ui/core/utils/helpers'
import * as React from 'react'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import { Link } from 'react-router-dom'
import {
  Button,
  Card,
  CardContent,
  FormControl,
  FormLabel,
  Paper,
} from '@material-ui/core'
import orange from '@material-ui/core/colors/orange'
import { makeStyles } from '@material-ui/styles'

import { MUIDataTableColumnDef } from 'mui-datatables'
import { useState } from 'react'
import { Form } from 'formik'
import { InlineDatePicker, MaterialUiPickersDate } from 'material-ui-pickers'
import { subMonths } from 'date-fns'
import Fetcher from '../../../components/Fetcher'
import { t } from '../../../i18n'
import { format } from '../../../i18n/format'
import targetOrderService, {
  TargetOrderView,
} from '../../../services/targetOrderService'
import TargetOrderList from '../../../components/TargetOrderList'

const useStyles = makeStyles(() => ({
  cell: {
    fontWeight: 'bold',
    color: orange[600],
  },
  formControl: {
    minWidth: 270,
  },
  marginY20: {
    marginBottom: 20,
    marginTop: 20,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '15px',
  },
}))

export const TraderTargetOrdersCanceled = () => {
  const classes = useStyles()
  const [startDate, setStartDate] = useState(subMonths(new Date(), 2))
  const [endDate, setEndDate] = useState(new Date())

  const getTableTargetOrderColumns = (): Array<
    string | MUIDataTableColumnDef
  > => [
    t('Client'),
    t('Date'),
    t('Produit'),
    t('Campagne'),
    { name: 'tons', label: t('Souscrit'), options: { filter: false } },
    {
      name: 'tonnageExecuted',
      label: t('Exécuté'),
      options: {
        filter: false,
        customBodyRender: (value: number) =>
          value !== 0 ? (
            <span className={classes.cell}>{value}</span>
          ) : (
            <span>{value}</span>
          ),
      },
    },
    t('Modalité'),
    t('Execution'),
    {
      name: 'customerTargetPrice',
      label: t('Objectif (€/t)'),
      options: { filter: false },
    },
  ]

  const targetOrderToTableData = (targetOrder: TargetOrderView) => [
    capitalize(targetOrder.customerSocialReason),
    format(targetOrder.builtAt, 'dd/MM/yyyy'),
    capitalize(targetOrder.productName),
    targetOrder.campaignName,
    targetOrder.tons,
    targetOrder.tonnageExecuted,
    capitalize(targetOrder.executionModeLabel),
    format(targetOrder.executionDate, 'MMMM yyyy'),
    targetOrder.customerTargetPrice,
  ]

  const fetchTargetOrder = () => {
    return targetOrderService.findAll(['CANCELED'], startDate, endDate)
  }

  const handleStartDateChange = (date: MaterialUiPickersDate) => {
    setStartDate(date)
  }

  const handleEndDateChange = (date: MaterialUiPickersDate) => {
    setEndDate(date)
  }

  const renderTargetOrderSaleCancel = (
    targetOrders: TargetOrderView[],
    refresh: () => void
  ) => {
    return (
      <>
        <Link to={'/sales/list'}>
          <Button color="primary">
            <KeyboardArrowLeft />
            {t('Retour à la liste des ventes')}
          </Button>
        </Link>
        <Card className={classes.marginY20}>
          <CardContent>
            <Form className={classes.row}>
              <FormControl className={classes.formControl}>
                <FormLabel htmlFor="startDateFilter">
                  {t('Start Date')}
                </FormLabel>
                <InlineDatePicker
                  id="startDateFilter"
                  name="startDate"
                  value={startDate}
                  onChange={handleStartDateChange}
                  invalidDateMessage={t('Date invalide')}
                  disableOpenOnEnter={true}
                  keyboard={true}
                  autoOk={true}
                  format={'dd/MM/yyyy'}
                />
              </FormControl>
              <FormControl className={classes.formControl}>
                <FormLabel htmlFor="endDateFilter">{t('End Date')}</FormLabel>
                <InlineDatePicker
                  id="endDateFilter"
                  name="endDate"
                  value={endDate}
                  onChange={handleEndDateChange}
                  invalidDateMessage={t('Date invalide')}
                  disableOpenOnEnter={true}
                  keyboard={true}
                  autoOk={true}
                  format={'dd/MM/yyyy'}
                />
              </FormControl>
              <Button onClick={refresh}>{t('Filtrer')}</Button>
            </Form>
          </CardContent>
        </Card>
        <TargetOrderList
          targetOrders={targetOrders}
          columns={getTableTargetOrderColumns()}
          tableDataMapper={targetOrderToTableData}
          refresh={refresh}
          status="CANCELED"
        />
      </>
    )
  }

  return (
    <>
      <Fetcher fetch={fetchTargetOrder}>{renderTargetOrderSaleCancel}</Fetcher>
    </>
  )
}

export default TraderTargetOrdersCanceled
